export default [
  {
    value: "cell",
    label: "Cell",
  },
  {
    value: "fax",
    label: "Fax",
  },
  {
    value: "mobile",
    label: "Mobile",
  },
  {
    value: "office",
    label: "Office",
  },
  {
    value: "pager",
    label: "Pager",
  },
  {
    value: "text",
    label: "Text",
  },
  {
    value: "video",
    label: "Video",
  },
  {
    value: "voice",
    label: "Voice",
  },
];
